import { JSONSchema7 } from 'json-schema';
import React, { useState } from 'react';
import {
  JSONSchemaFormProps,
  AnyOfSelections,
} from 'src/modules/shared/types/json-schema.type';
import { JSONSchemaField } from './json-schema-field';
import {
  cleanValueForSchema,
  isValueEmptyForSchema,
} from 'src/modules/shared/utils/json-schema.util';

/**
 * A form component that renders inputs based on a JSON Schema
 */
export const JSONSchemaForm: React.FC<JSONSchemaFormProps> = ({
  schema,
  formData,
  onChange,
  uiSchema = {},
  disabled = false,
  className = '',
  allFieldsOptional = false,
}) => {
  const [anyOfSelections, setAnyOfSelections] = useState<AnyOfSelections>({});

  if (!schema.properties) {
    return null;
  }

  const handleChange = (key: string, value: unknown) => {
    const fieldSchema = schema.properties?.[key] as JSONSchema7 | undefined;

    if (allFieldsOptional) {
      const cleanedValue = cleanValueForSchema(fieldSchema, value);
      const next = { ...formData };

      if (isValueEmptyForSchema(fieldSchema, cleanedValue)) {
        delete next[key];
      } else {
        next[key] = cleanedValue;
      }

      onChange(next);
      return;
    }

    onChange({ ...formData, [key]: value });
  };

  return (
    <div className={className}>
      {Object.entries(schema.properties).map(([key, fieldSchema]) => (
        <JSONSchemaField
          key={key}
          fieldKey={key}
          schema={schema}
          fieldSchema={fieldSchema as JSONSchema7}
          formData={formData}
          handleChange={handleChange}
          uiSchema={uiSchema}
          disabled={disabled}
          allFieldsOptional={allFieldsOptional}
          anyOfSelections={anyOfSelections}
          setAnyOfSelections={setAnyOfSelections}
          JSONSchemaForm={JSONSchemaForm}
        />
      ))}
    </div>
  );
};
